import React from 'react';
import Select from './advanced-select';

export default class SearchSelect extends React.Component {
    render() {
        return (
            <Select
                {...this.props}
                className={['component-search-select', 'search-module', this.props.className].join(' ')}
                multi={this.props.multi}
                />
        )
    }
}


// WEBPACK FOOTER //
// ./web-app/components/search-select.jsx